// msalConfig.ts — Microsoft Entra External ID (MSAL) configuration from env.
// All tenant-specific values come from VITE_ENTRA_* (.env, never committed).
// When VITE_ENTRA_CLIENT_ID is blank, auth is considered DISABLED and the app
// runs unauthenticated — the intended local/mock developer experience.
//
// NOTE: this module must not import @azure/msal-* at runtime (type-only is
// fine) — the MSAL libraries are large and load lazily via msalRuntime.tsx
// only when Entra is configured.

import type { Configuration, PopupRequest } from '@azure/msal-browser';

export const authEnabled = Boolean(import.meta.env.VITE_ENTRA_CLIENT_ID);

/** Auth + cache config; logger options are attached in msalRuntime.tsx. */
export const msalConfigBase: Omit<Configuration, 'system'> = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID ?? '',
    authority: import.meta.env.VITE_ENTRA_AUTHORITY ?? '',
    redirectUri: import.meta.env.VITE_ENTRA_REDIRECT_URI ?? window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_ENTRA_REDIRECT_URI ?? window.location.origin,
    // Entra External ID authorities are not in the known-authorities list by default.
    knownAuthorities: import.meta.env.VITE_ENTRA_AUTHORITY
      ? [new URL(import.meta.env.VITE_ENTRA_AUTHORITY).host]
      : [],
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

/** Scopes requested at login. */
export const loginRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'email'],
};

/** API scope used to acquire access tokens for the PharmacyIQ API. */
export const apiScopes: string[] = import.meta.env.VITE_ENTRA_API_SCOPE
  ? [import.meta.env.VITE_ENTRA_API_SCOPE]
  : [];
